"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createSitemapGenerator = void 0;
function filterNullish(val) {
    return val.filter((item) => item !== null && item !== undefined);
}
class SitemapGenerator {
    constructor(options) {
        this.routeResolvers = {};
        this.options = null;
        this.exhaustive = () => this;
        this.toXml = () => {
            return this.getSitemapItems().then((sitemapItems) => {
                return `<?xml version="1.0" encoding="UTF-8"?>
        <urlset xmlns="http://www.sitemaps.org/schemas/sitemap/0.9" xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance" xsi:schemaLocation="http://www.sitemaps.org/schemas/sitemap/0.9 http://www.sitemaps.org/schemas/sitemap/0.9/sitemap.xsd">
            ${sitemapItems
                    .map((item) => {
                    var _a, _b;
                    return `<url>
                        <loc>${(_b = (_a = this.options) === null || _a === void 0 ? void 0 : _a.baseUrl) !== null && _b !== void 0 ? _b : ""}${item.loc}</loc>
                            ${item.priority ? `<priority>${item.priority}</priority>` : ""}
                            ${item.lastmod ? `<lastmod>${item.lastmod}</lastmod>` : ""}
                            ${item.changefreq ? `<changefreq>${item.changefreq}</changefreq>` : ""}
                        </url>`;
                })
                    .join("")}
        </urlset>`;
            });
        };
        this.toJson = () => this.getSitemapItems().then(JSON.stringify);
        this.options = options !== null && options !== void 0 ? options : null;
    }
    async getSitemapItems() {
        const routes = Object.keys(this.routeResolvers);
        const allSitemapItems = await Promise.all(routes.map((route) => { var _a, _b; return (_b = (_a = this.routeResolvers)[route]) === null || _b === void 0 ? void 0 : _b.call(_a, route); })).then((resolverResults) => {
            const sitemapItems = [];
            resolverResults.forEach((result) => {
                if (!result) {
                    return;
                }
                if (Array.isArray(result)) {
                    sitemapItems.push(...filterNullish(result));
                    return;
                }
                sitemapItems.push(result);
            });
            return sitemapItems;
        });
        return allSitemapItems.map((sitemapItem) => {
            var _a, _b;
            return ({
                ...sitemapItem,
                changefreq: sitemapItem.changefreq !== undefined ? sitemapItem.changefreq : (_a = this.options) === null || _a === void 0 ? void 0 : _a.defaultChangeFreq,
                priority: sitemapItem.priority !== undefined ? sitemapItem.priority : (_b = this.options) === null || _b === void 0 ? void 0 : _b.defaultPriority,
            });
        });
    }
    add(route, resolver) {
        this.routeResolvers[route] = resolver;
        return this;
    }
    skip() {
        return this;
    }
}
const createSitemapGenerator = (options) => new SitemapGenerator(options);
exports.createSitemapGenerator = createSitemapGenerator;
